import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ApiClient from "../services/api-client"
import { useTranslation } from 'react-i18next';
import VivaFooter from '../img/viva_footer.png';
import { getCurrentUser } from '../util/AuthUtils';
import { toast } from 'react-toastify';
import { CustomConfirmAlert as confirmAlert } from '../components/custom-confirm-alert';
import {useNavigate} from 'react-router-dom';
import { VIVA_VIEW_TRANSACTION } from '../util/constants';
import Modal from 'react-bootstrap/Modal';
import ActivateLicence from "./activate-licence";
import MyDataLogo from "../img/mydata.png";
import useStore from '../hooks/useStore';

const formatPrice = (amount, isYearly) => {
    const euros = isYearly ? (amount / 100 / 12 / 1.17) : (amount / 100 / 1.17);
    return euros.toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
};

const PricingCard = ({ pkg, onOrder, isYearly }) => (
    <div className="subscription-card">
        <div className="subscription-card-badge">
            <img src={MyDataLogo} alt="myDATA" className="subscription-mydata-logo" />
        </div>
        <div className="subscription-card-invoices">
            <span className="subscription-invoice-count">
                {pkg.invoices ? pkg.invoices.toLocaleString('el-GR') : '∞'}
            </span>
            <span className="subscription-invoice-label">
                {pkg.invoices ? (isYearly ? 'τιμολόγια/έτος' : 'τιμολόγια/μήνα') : 'απεριόριστα'}
            </span>
        </div>
        <ul className="subscription-features">
            <li><i className="fa fa-check-circle"></i> myDATA / ΑΑΔΕ</li>
            <li><i className="fa fa-check-circle"></i> Αυτόματη μετάδοση</li>
            <li><i className="fa fa-check-circle"></i> PDF τιμολόγια</li>
        </ul>
        <button
            className="btn btn-skin subscription-cta-btn"
            onClick={e => onOrder(e, pkg.id)}
        >
            Ξεκινήστε με {pkg.price}
        </button>
    </div>
);

export default function Paymemnt() {

    const { register, formState: { errors }, getValues } = useForm();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [showLicenceKeyModal, setShowLicenceKeyModal] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState('0');
    const [monthlyPackages, setMonthlyPackages] = useState([]);
    const [yearlyPackages, setYearlyPackages] = useState([]);

    useEffect(() => {
        ApiClient.getPaymentPackages().then(response => {
            const pkgs = response.data;
            setMonthlyPackages(pkgs.filter(p => p.paymentType === 'MONTHLY').map(p => ({
                id: p.name,
                invoices: p.displayInvoices,
                price: formatPrice(p.amount, false),
            })));
            setYearlyPackages(pkgs.filter(p => p.paymentType === 'YEARLY').map(p => ({
                id: p.name,
                invoices: p.displayInvoices,
                price: formatPrice(p.amount, true),
            })));
        }).catch(err => console.error(err));
    }, []);

    useEffect(() => {
        let mounted = true;
        getCurrentUser()
            .then(response => {
                if (response == undefined) {
                }
                else {
                    localStorage.setItem("user", JSON.stringify(response.user))
                    if (response.companies && response.companies.length == 1) {
                        localStorage.setItem("company", JSON.stringify(response.companies[0]))
                    }
                }
                let errorOnPayment = localStorage.getItem("errorOnPayment")
                if (errorOnPayment) {
                    toast.error(errorOnPayment, { autoClose: 5000 })
                    localStorage.removeItem("errorOnPayment")
                }
            }).catch(error => {
                console.error(error)
            });

        return () => mounted = false;

    }, []);

    const createOrder = (e, packId) => {
        if (paymentMethod === '0') {
            ApiClient.createReccuringPaymentOrder(packId).then(
                (response) => {
                    if (response.data.Success) {
                        localStorage.setItem("packId", packId);
                        window.location = VIVA_VIEW_TRANSACTION + "/web/checkout?ref=" + response.data.OrderCode;
                    }
                },
                error => {
                    console.error(
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString())
                }
            )
        } else {
            ApiClient.createPaymentOrder(packId).then(
                (response) => {
                    if (response.data.Success) {
                        localStorage.setItem("packId", packId);
                        window.location = VIVA_VIEW_TRANSACTION + "/web/checkout?ref=" + response.data.OrderCode + "&paymentMethod=" + paymentMethod;
                    }
                },
                error => {
                    console.error(
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString())
                }
            )
        }
    }

    const CreateVivaOrder = () => {
        ApiClient.createVivaOrder().then(
            (response) => {
                var resp = JSON.parse(response.data.response);
                if (resp.Success) {
                    localStorage.setItem("packId", response.data.packId);
                    window.location = VIVA_VIEW_TRANSACTION + "/web/checkout?ref=" + resp.OrderCode;
                }
                else {
                    console.error(resp)
                }
            },
            error => {
                console.error(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString())
            }
        )
    }

    const CreateTransaction = () => {
        ApiClient.createUserTransaction({}).then(
            (response) => {
                var resp = response.data;
                if (resp.Success) {
                    toast.success("Your payment has complete")
                    getCurrentUser()
                        .then(response => {
                            localStorage.setItem("user", JSON.stringify(response.user))
                            window.location.reload();
                        }).catch(error => {
                            console.error(error)
                            if (error.status === 401) {
                                navigate("/login")
                            }
                        });
                }
                else {
                    toast.error(resp.ErrorText)
                }
            },
            error => {
                console.error(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString())
            }
        )
    }

    const cancelSubscription = () => {
        confirmAlert({
            title: t("submitConfirm"),
            message: t("confirmCancelSubscription"),
            closeOnEscape: false,
            closeOnClickOutside: false,
            buttons: [
                {
                    label: "Ok",
                    onClick: () => {
                        ApiClient.cancelSubscription().then(
                            (response) => {
                                console.log(response)
                                localStorage.removeItem("user");
                                localStorage.removeItem("wizard");
                                window.location = "login";
                            },
                            error => {
                                console.error(
                                    (error.response &&
                                        error.response.data &&
                                        error.response.data.message) ||
                                    error.message ||
                                    error.toString())
                            }
                        )
                    },
                },
                {
                    label: t('Cancel')
                }
            ]
        });
    }

    const insertLicenceKey = () => {
        setShowLicenceKeyModal(true)
    }

    const goBack = () => {
        navigate(-1);
    }

    const choosePackageContainer = (
        <div className="startSubscription-container">
            <div className="subscription-wrapper">

                <div className="subscription-header text-center">
                    <div className="subscription-header-icon">
                        <i className="fa fa-rocket"></i>
                    </div>
                    <h2 className="subscription-title">Ανανεώστε τη συνδρομή σας!</h2>
                    <p className="subscription-subtitle">
                        Επίλεξε το πλάνο που σου ταιριάζει. Οι συνδρομές ανανεώνονται αυτόματα εκτός κι αν ακυρωθούν.
                    </p>
                </div>

                <ul className="nav justify-content-center subscription-tabs mb-4" id="subTab" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button
                            className="nav-link active subscription-tab-btn"
                            id="monthly-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#monthly-packs"
                            type="button"
                            role="tab"
                        >
                            {t("monthlyPacks")}
                        </button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button
                            className="nav-link subscription-tab-btn"
                            id="yearly-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#yearly-packs"
                            type="button"
                            role="tab"
                        >
                            {t("yearlyPacks")}
                            <sup><span className="badge bg-success yearlyPercentDiscount">-18%</span></sup>
                        </button>
                    </li>
                </ul>

                <div className="tab-content">
                    <div className="tab-pane fade show active" id="monthly-packs" role="tabpanel">
                        <div className="row justify-content-center g-3 px-3">
                            {monthlyPackages.map(pkg => (
                                <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6" key={pkg.id}>
                                    <PricingCard pkg={pkg} onOrder={createOrder} />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="tab-pane fade" id="yearly-packs" role="tabpanel">
                        <p className="text-center subscription-yearly-note">
                            <i className="fa fa-tag" style={{ marginRight: 6 }}></i>
                            Οι παρακάτω τιμές αναφέρονται σε 12 μήνες συνδρομή
                        </p>
                        <div className="row justify-content-center g-3 px-3">
                            {yearlyPackages.map(pkg => (
                                <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6" key={pkg.id}>
                                    <PricingCard pkg={pkg} onOrder={createOrder} isYearly />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="subscription-payment-row">
                    <div className="subscription-payment-selector">
                        <label className="inputlabel">
                            <i className="fa fa-credit-card" style={{ marginRight: 6 }}></i>
                            Τρόπος πληρωμής
                        </label>
                        <select
                            value={paymentMethod}
                            onChange={e => setPaymentMethod(e.target.value)}
                            className="form-select subscription-payment-select"
                        >
                            <option value="0">ΚΑΡΤΑ (προτεινόμενος)</option>
                            <option value="3">ΜΕΤΡΗΤΑ</option>
                            <option value="4">e-banking</option>
                        </select>
                    </div>
                    <p className="subscription-vat-note">* Στις τιμές δεν περιλαμβάνεται Φ.Π.Α.</p>
                </div>

                <div className="subscription-footer">
                    <p className="subscription-legal">
                        Γίνονται δεκτές πιστωτικές ή χρεωστικές κάρτες Visa, Mastercard ή American Express, μετρητά ή e-banking.
                        Οι συναλλαγές πραγματοποιούνται μέσω του αδειοδοτημένου ιδρύματος πληρωμών <strong>Viva Payments</strong>,
                        εγγυώμενο ασφαλές περιβάλλον. Τα στοιχεία της κάρτας σας δεν αποθηκεύονται στους διακομιστές μας.
                    </p>
                    <p>
                        Εαν έχετε κλειδί ενεργοποίησης παρακαλώ πατήστε <a href="#" onClick={insertLicenceKey}>εδώ</a>
                    </p>
                    <a
                        href="https://timologic.gr/blog/tropoi-pliromis/"
                        target="_blank"
                        rel="noreferrer"
                        className="subscription-payment-link"
                    >
                        <i className="fa fa-external-link" style={{ marginRight: 6 }}></i>
                        Τρόποι πληρωμής
                    </a>
                    <div className="subscription-viva-logo">
                        <img src={VivaFooter} alt="Viva Payments" />
                    </div>
                </div>

                <Modal
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={showLicenceKeyModal}
                    keyboard={false}
                >
                    <Modal.Header>
                        <Modal.Title>{t("ActivateLicence")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <ActivateLicence></ActivateLicence>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-skin" onClick={() => setShowLicenceKeyModal(false)}>{t("cancel")}</button>
                    </Modal.Footer>
                </Modal>

            </div>
        </div>
    );

    const paymentContainer = (
        <div className="startSubscription-container">
            <div className="subscription-wrapper">

                <div className="subscription-header text-center">
                    <div className="subscription-header-icon">
                        <i className="fa fa-refresh"></i>
                    </div>
                    <h2 className="subscription-title">{t("paySubscription")}</h2>
                    <p className="subscription-subtitle">{t("subscriptionHasEndUp")}</p>
                    <p className="subscription-subtitle">{t("subscriptionHasEndDown")}</p>
                    <p className="subscription-subtitle">
                        Για πληροφορίες επικοινωνήστε στο <strong>210 4441685</strong> ή ανοίξτε ένα{' '}
                        <a href="https://timologic.gr/blog/support/" target="_blank" rel="noreferrer">Support Ticket</a>.
                    </p>
                </div>

                <div className="row justify-content-center g-3 px-3 mb-4">
                    <div className="col-lg-4 col-md-6" style={{display:'none'}}>
                        <div className="subscription-card">
                            <div className="subscription-card-invoices">
                                <i className="fa fa-repeat" style={{ fontSize: 32, color: 'var(--appcolor)', marginBottom: 8 }}></i>
                                <span className="subscription-invoice-label">{t("repeatTransaction")}</span>
                            </div>
                            <ul className="subscription-features">
                                <li><i className="fa fa-check-circle"></i> Χρήση αποθηκευμένης κάρτας</li>
                                <li><i className="fa fa-check-circle"></i> Άμεση ενεργοποίηση</li>
                            </ul>
                            <button className="btn btn-skin subscription-cta-btn" onClick={CreateTransaction}>
                                {t("repeatTransaction")}
                            </button>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="subscription-card">
                            <div className="subscription-card-invoices">
                                <i className="fa fa-credit-card" style={{ fontSize: 32, color: 'var(--appcolor)', marginBottom: 8 }}></i>
                                <span className="subscription-invoice-label">{t("payWithNewCard")}</span>
                            </div>
                            <ul className="subscription-features">
                                <li><i className="fa fa-check-circle"></i> Νέα κάρτα ή e-banking</li>
                                <li><i className="fa fa-check-circle"></i> Ασφαλής πληρωμή μέσω Viva</li>
                            </ul>
                            <button className="btn btn-skin subscription-cta-btn" onClick={CreateVivaOrder}>
                                {t("payWithNewCard")}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="subscription-footer">
                    <p className="subscription-vat-note">
                        <i className="fa fa-exchange" style={{ marginRight: 6 }}></i>
                        Αν θέλετε να αλλάξετε τύπο συνδρομής (από ετήσια σε μηνιαία και αντίστροφα) πατήστε{' '}
                        <a href="startSubscription">εδώ</a>.
                    </p>
                    <p className="subscription-legal">
                        Γίνονται δεκτές πιστωτικές ή χρεωστικές κάρτες Visa, Mastercard ή American Express, μετρητά ή e-banking.
                        Οι συναλλαγές πραγματοποιούνται μέσω του αδειοδοτημένου ιδρύματος πληρωμών <strong>Viva Payments</strong>,
                        εγγυώμενο ασφαλές περιβάλλον. Τα στοιχεία της κάρτας σας δεν αποθηκεύονται στους διακομιστές μας.
                    </p>
                    <a
                        href="https://timologic.gr/blog/tropoi-pliromis/"
                        target="_blank"
                        rel="noreferrer"
                        className="subscription-payment-link"
                    >
                        <i className="fa fa-external-link" style={{ marginRight: 6 }}></i>
                        Τρόποι πληρωμής
                    </a>
                    <div className="subscription-viva-logo">
                        <img src={VivaFooter} alt="Viva Payments" />
                    </div>
                    <button className="btn btn-outline-danger btn-sm mt-3" onClick={cancelSubscription}>
                        <i className="fa fa-times" style={{ marginRight: 6 }}></i>
                        {t("cancelSubscription")}
                    </button>
                </div>

            </div>
        </div>
    );

    const noActionContainer = <div className="container text-center">
        <br></br><br></br><br></br><br></br><br></br><br></br>
        <h3><button onClick={goBack} className="btn btn-skin">{t("GoBack")}</button></h3>
        <br></br>
    </div>

    const _user = useStore.getState().loggedInUser;
    const container = _user?.lastTransactionDate == null ? choosePackageContainer : (_user?.userStatus == "ACTIVE" ? noActionContainer : paymentContainer)

    return (
        container
    );
}
